import { type ParagrafoDTO } from '@framework/api-client/api/inquiries/schemas/paragrafoDTO.ts';
import styled from 'styled-components';
import { CoverParagraphViewItem } from './CoverParagraphViewItem.tsx';

const CoverParagraphsContainer = styled.div`
  padding-top: 24px;
`;

function generateKey(paragraph: ParagrafoDTO, index: number) {
  return `${paragraph.titolo?.split(' ')[0] ?? 'p'}-${index}`;
}
export interface ICoverParagraphsProps {
  paragraphs: ParagrafoDTO[] | null | undefined;
}

/**
 * Componente per la visualizzazione dei paragrafi di copertina
 */
export function CoverParagraphs(props: ICoverParagraphsProps) {
  const { paragraphs } = props;
  if (!paragraphs) return null;

  return (
    <CoverParagraphsContainer>
      {paragraphs.map((paragraph, i) => (
        <CoverParagraphViewItem
          title={paragraph.titolo}
          text={paragraph.corpo}
          key={generateKey(paragraph, i)}
        />
      ))}
    </CoverParagraphsContainer>
  );
}
